import { authenticationService } from "@authentication/services/AuthenticationService";
import { invenioConfig } from "@config";
import { BackOfficeRoutes } from "@routes/urls";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Link, withRouter } from "react-router-dom";
import { Divider, Menu } from "semantic-ui-react";
import { sessionManager } from "@authentication/services/SessionManager";

class AdminMenu extends Component {
  removeTrailingSlashes = (path) => path.replace(/\/+$/, "");

  hasAdminOrLibrarianRole = () => {
    const sessionUser = sessionManager.user;
    const propsUser = this.props.user;
    const user = sessionUser || propsUser;

    if (!user) {
      return false;
    }

    // Check if user has admin or librarian role
    return authenticationService.hasRoles(user, ["admin", "librarian"]);
  };

  isAdmin = () => {
    // Check if user is specifically an admin
    const sessionUser = sessionManager.user;
    const propsUser = this.props.user;
    const user = sessionUser || propsUser;

    if (!user) {
      return false;
    }

    return authenticationService.hasRoles(user, ["admin"]);
  };

  render() {
    const { location } = this.props;
    const activePath = this.removeTrailingSlashes(location.pathname);

    // Check if user has required permissions
    const hasAccess = this.hasAdminOrLibrarianRole();
    const isAdmin = this.isAdmin();

    // If user doesn't have access, don't render the menu
    if (!hasAccess) {
      return null;
    }

    // Define active states for each menu item
    const configurablesActive = activePath.includes(
      BackOfficeRoutes.configurables
    );
    const collegeActive = activePath.includes(BackOfficeRoutes.college);

    return (
      <Overridable id="AdminMenu.layout">
        <>
          <Divider horizontal className="bo-admin-menu-divider">
            Administration
          </Divider>
          <Menu text vertical className="bo-menu bo-menu-footer">
            <Menu.Item>
              <Menu.Menu>
                <Menu.Item
                  as={Link}
                  to={BackOfficeRoutes.configurables}
                  active={configurablesActive}
                  style={{ paddingLeft: "2rem" }}
                >
                  System Configurations
                </Menu.Item>
                <Menu.Menu
                  style={{
                    marginLeft: "1rem",
                  }}
                >
                  <Menu.Item
                    as={Link}
                    to={BackOfficeRoutes.college}
                    active={collegeActive}
                    style={{ paddingLeft: "1rem" }}
                  >
                    College and Program
                  </Menu.Item>

                  {/* Only show Admin panel and Static pages to admins */}
                  {isAdmin && (
                    <>
                      <Menu.Item
                        as="a"
                        href={`${invenioConfig.APP.INVENIO_UI_URL}/admin`}
                        target="_blank"
                        style={{ paddingLeft: "1rem" }}
                      >
                        Admin panel
                      </Menu.Item>
                      <Menu.Item
                        as="a"
                        href={`${invenioConfig.APP.INVENIO_UI_URL}/admin/page`}
                        target="_blank"
                        style={{ paddingLeft: "1rem" }}
                      >
                        Static pages
                      </Menu.Item>
                    </>
                  )}
                </Menu.Menu>
              </Menu.Menu>
            </Menu.Item>
          </Menu>
        </>
      </Overridable>
    );
  }
}

AdminMenu.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  user: PropTypes.object,
};

AdminMenu.defaultProps = {
  location: {
    pathname: "",
  },
};

export default Overridable.component("AdminMenu", withRouter(AdminMenu));
